module.exports = __webpack_public_path__ + "static/media/icon-desktop-phone.6c4ed214.svg";